import merge from 'lodash/merge';

import { dashboardSsoApi } from './http';
import { getQlikToken } from './qlik';

export async function login(email, password) {
  const response = await dashboardSsoApi.get(`/auth/v1/token/?username=${email}&password=${password}`);

  const { customerId } = response.data.customer;
  const { token } = response.data;
  const passwordHash = response.data.user.password;

  const { authToken, qlikToken } = await getQlikToken(customerId, email, passwordHash, token);
  // const authToken = 'ZmxvcmlkYV9mYkB4b3NkaWdpdGFsLmNvbTpHY1pFS29lM0dPWHdIeWNIZE9EZTBnPT0=';
  // const qlikToken = 'x-OusykOzpa80otQ';

  // eslint-disable-next-line no-console
  console.log(`authToken: ${authToken} + qlikToken: ${qlikToken}`);

  return merge(response.data, { authToken, qlikToken });
}
